import SvgSprite from '@/components/atomic/atoms/data-display/icons/icon-sprite/styled';
import type { ListCtaProps } from '@/components/atomic/atoms/data-display/list/cta/typings';
import Cta from '@/components/atomic/atoms/navigation/cta/styled';
import styled, { CSSObject } from '@emotion/styled';

const ListCta = styled(Cta)<ListCtaProps>(({
	theme,
	$hasIcon,
	$linkType = 'secondary',
}) => {
	let style: CSSObject = {};

	let spanStyle: CSSObject = {
		fontSize: 11,
		fontWeight: 600,
		fontFamily: theme.font.families.secondary.demiBold,
	};

	let svgStyle: CSSObject = {
		position: 'absolute',
		top: '50%',
		transform: 'translateY(-50%)',
	};

	let hoverSpanStyle: CSSObject = {};

	switch ($linkType) {
		case 'secondary':
			if ($hasIcon) {
				style = {
					...style,
					paddingLeft: 18,
				};
			}
			spanStyle = {
				...spanStyle,
				color: theme.colors.primaryBrandColor,
				lineHeight: '14.5px',
				letterSpacing: '1.8px',
			};
			svgStyle = {
				...svgStyle,
				width: 11,
				height: 11,
				left: 0,
			};
			hoverSpanStyle = {
				textDecoration: 'underline',
			};
			break;
	}

	style = {
		...style,
		'&:hover': {
			span: hoverSpanStyle,
		},
		span: spanStyle,
		[`${SvgSprite}`]: svgStyle,
	};

	return style;
});

export default ListCta;
